<template>
  <div class="cx_barcode_setting">  
      <div>
            <div class="cx_barcode_setting_item">
                <div class="cx_barcode_caption" tabindex="-1">カウントアップ方法<i   class="material-symbols-outlined  small valign help" ref="tooltip_target1">help_outline</i></div>
                <toggle-button v-model="autoCountUp" sync :labels="{checked:'自動', unchecked:'手動'}" :width="80" :font-size="11" color="#0761AB"/>
            </div>    
            <div class="cx_barcode_setting_item">
                <div class="cx_barcode_caption" tabindex="-1">検品済み伝票の表示<i   class="material-symbols-outlined small valign help" ref="tooltip_target2">help_outline</i></div>
                <toggle-button v-model="showCompletedVoucher" sync :labels="{checked:'表示', unchecked:'非表示'}" :width="80" :font-size="11" color="#0761AB"/>
            </div>
            <div class="cx_barcode_setting_item" v-if="cameraEnabled">
            <div class="cx_barcode_caption" tabindex="-1">読取デバイス<i   class="material-symbols-outlined small valign help" ref="tooltip_target3">help_outline</i></div>
            <toggle-button v-model="readerEnabled" sync :labels="{checked:'スキャナ', unchecked:'カメラ'}" :width="80" :font-size="11" color="#0761AB"/>
            </div>
            <div class="cx_barcode_setting_item">
                <div class="cx_barcode_caption" tabindex="-1">検品モード<i   class="material-symbols-outlined small valign help" ref="tooltip_target4">help_outline</i></div>
                <b-form-radio-group v-if="$api.customFunctionOpen($api.customFunctionFlags.scanRegistration)" class="cx_barcode_setting_mode" v-model="iinspectionMode" buttons name="inspection-application-mode">
                    <b-form-radio button-variant="outline-primary" :value="inspectionAppModes.shippingAndReceipt">入出荷検品</b-form-radio>
                    <b-form-radio button-variant="outline-primary" :value="inspectionAppModes.salesAndPurchaseOrder">受発注検品</b-form-radio>
                    <b-form-radio button-variant="outline-primary" :value="inspectionAppModes.scanRegistration">スキャン登録</b-form-radio>
                </b-form-radio-group>
                <toggle-button v-else v-model="isEnabledOrderInspection" sync :labels="{checked:'受発注', unchecked:'入出荷'}" :width="80" :font-size="11" color="#0761AB"/>
            </div>
            <div class="cx_barcode_setting_item" v-if="$api.customFunctionOpen($api.customFunctionFlags.scanRegistration) && inspectioAppMode !== inspectionAppModes.salesAndPurchaseOrder">
                <div class="cx_barcode_caption" tabindex="-1">検品完了時の伝票状態<i   class="material-symbols-outlined small valign help" ref="tooltip_target5">help_outline</i></div>
                <toggle-button v-model="confirmVoucherStateOnInspectionCompleted" sync :labels="{checked:'確定', unchecked:'保存'}" :width="80" :font-size="11" color="#0761AB"/>
            </div>
      </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

enum IinspectionMode {
    shippingAndReceipt = 'shippingAndReceipt',
    salesAndPurchaseOrder = 'salesAndPurchaseOrder',
    scanRegistration = 'scanRegistration'
}

@Component
export default class BarcodeSetting extends Vue {

    autoCountUp: boolean=false;
    showCompletedVoucher:boolean= false;
    readerEnabled:boolean = false;
    isEnabledOrderInspection: boolean = false;
    cameraEnabled:boolean = false;
    iinspectionMode: IinspectionMode = IinspectionMode.shippingAndReceipt;
    inspectionAppModes = IinspectionMode;
    confirmVoucherStateOnInspectionCompleted: boolean = false;
    mounted(){        
      this.autoCountUp =  localStorage['autoCountUp'] != 'false'; //初期値はtrue
      this.showCompletedVoucher =  localStorage['showCompletedVoucher'] == 'true'; //初期値はfalse      
      this.readerEnabled =  localStorage['readerEnabled'] != 'false'; //初期値はtrue
      this.isEnabledOrderInspection =  localStorage['isEnabledOrderInspection'] == 'true'; //初期値はfalse
      this.confirmVoucherStateOnInspectionCompleted = localStorage['confirmVoucherStateOnInspectionCompleted'] == 'true'; //初期値はfalse
      const iinspectionMode = localStorage['iinspectionMode'] as IinspectionMode;
      
      if (this.canShowScanRegistration) {
        const inspectionAppModes = [IinspectionMode.shippingAndReceipt, IinspectionMode.salesAndPurchaseOrder, IinspectionMode.scanRegistration];
        if (inspectionAppModes.indexOf(iinspectionMode) >= 0) this.iinspectionMode = iinspectionMode;
        else if (localStorage['isEnabledScanRegistration'] == 'true') this.iinspectionMode = IinspectionMode.scanRegistration;
        else if (this.isEnabledOrderInspection) this.iinspectionMode = IinspectionMode.salesAndPurchaseOrder;
        else this.iinspectionMode = IinspectionMode.shippingAndReceipt;
      } else if (this.isEnabledOrderInspection) this.iinspectionMode = IinspectionMode.salesAndPurchaseOrder;
      else this.iinspectionMode = IinspectionMode.shippingAndReceipt;
      this.saveIinspectionMode();

      //毎回初期化する(ライセンスの状況が同じとは限らない)
      navigator.mediaDevices.enumerateDevices().then(devices =>{
        //カメラデバイスがあり検品デバイス数が設定されている場合にカメラゾーンを有効化する
        this.cameraEnabled = devices.filter((device) => device.kind === 'videoinput').length > 0 && this.$api.license.hasScannerLicense;
        this.$nextTick(()=>{
            this.$api.tooltip.mount(this, this.$refs.tooltip_target1 as Element,"バーコード読取時に自動でカウントアップするかどうかを指定します。");         
            this.$api.tooltip.mount(this, this.$refs.tooltip_target2 as Element,"検品済み伝票を表示するかどうかを指定します。");        
            this.$api.tooltip.mount(this, this.$refs.tooltip_target3 as Element,"バーコード読取を背面カメラで行うか外部スキャナで行うかを指定します。");   
            this.$api.tooltip.mount(this, this.$refs.tooltip_target4 as Element,this.canShowScanRegistration ? "入出荷検品、受発注検品、スキャン登録のいずれを行うかを指定します。\n入出荷検品: 入荷伝票、出荷伝票の検品を行います。\n受発注検品: 受注伝票、発注伝票の検品を行います。\nスキャン登録: バーコードをスキャンして伝票を作成します。" : "入出荷検品、受発注検品のどちらを行うかを指定します。"); 
            if (this.$refs.tooltip_target5) this.$api.tooltip.mount(this, this.$refs.tooltip_target5 as Element,"検品完了時に作成・更新する伝票の状態を指定します。");
        });        
      });      
                                
    }
  public get canShowScanRegistration():boolean {
    return this.$api.customFunctionOpen(this.$api.customFunctionFlags.scanRegistration);
  }
  private saveIinspectionMode(){
    if (this.canShowScanRegistration == false) this.iinspectionMode = this.isEnabledOrderInspection ? IinspectionMode.salesAndPurchaseOrder : IinspectionMode.shippingAndReceipt;
    localStorage['iinspectionMode'] = this.iinspectionMode;
    localStorage['isEnabledScanRegistration'] = this.iinspectionMode == IinspectionMode.scanRegistration ? 'true' : 'false';
    localStorage['isEnabledOrderInspection'] = this.iinspectionMode == IinspectionMode.salesAndPurchaseOrder ? 'true' : 'false';
    this.isEnabledOrderInspection = this.iinspectionMode == IinspectionMode.salesAndPurchaseOrder;
  }
  @Watch('readerEnabled')
  public onReaderEnabledChanged() {
    localStorage['readerEnabled'] = this.readerEnabled;
  }
  @Watch('showCompletedVoucher')
  public onShowCompletedVoucherChanged() {
    localStorage['showCompletedVoucher'] = this.showCompletedVoucher;      
  }  
  @Watch('autoCountUp')
  public onAutoCountUpChanged() {
    localStorage['autoCountUp'] = this.autoCountUp;      
  }
  @Watch('isEnabledOrderInspection')
  public onIsEnabledOrderInspectionChanged() {
    if (this.canShowScanRegistration == false) {
      this.iinspectionMode = this.isEnabledOrderInspection ? IinspectionMode.salesAndPurchaseOrder : IinspectionMode.shippingAndReceipt;
      localStorage['iinspectionMode'] = this.iinspectionMode;
      localStorage['isEnabledScanRegistration'] = 'false';
    }
    localStorage['isEnabledOrderInspection'] = this.isEnabledOrderInspection;
  }
  @Watch('iinspectionMode')
  public onIinspectionModeChanged() {
    this.saveIinspectionMode();
    this.$nextTick(()=>{
      if (this.$refs.tooltip_target5) this.$api.tooltip.mount(this, this.$refs.tooltip_target5 as Element,"検品完了時に、伝票を保存状態とするか確定状態とするかを指定します。");
    });
  }
  @Watch('confirmVoucherStateOnInspectionCompleted')
  public onconfirmVoucherStateOnInspectionCompletedChanged() {
    localStorage['confirmVoucherStateOnInspectionCompleted'] = this.confirmVoucherStateOnInspectionCompleted;
  }
}
</script>
<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_barcode_setting{
    width: 100%;
    height: 100%;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .cx_barcode_setting_item{
        margin: 10px 0px;
        display: flex;
        align-items: center;        
        label {
            margin-bottom: unset;
        }
    }
    .cx_barcode_setting_mode{
        display:flex;
        flex-wrap: wrap;
        max-width: 310px;
        label {
            min-width: 95px;
            font-size: 11px;
        }
    }
    .cx_barcode_caption{
        display: flex;
        text-align: left;
        width : 250px;
        height: 32px;
        margin-left:5px;
        align-items: center;
        i {
        margin-left:2px;
        margin-bottom:0px;
        margin-right:0px;
        font-size: 24px ;
        color:#9e9d9d;      

            &:hover{
                color:#007bff;                
                cursor:pointer;
            }      

        }          
    }
    @media screen and (max-width: 680px) {
        justify-content: flex-start;
        padding: 20px 10px;
        .cx_barcode_setting_item{
            align-items: flex-start;
            flex-direction: column;
        }
        .cx_barcode_caption{
            width: 100%;
        }
    }
}
</style>
